module.exports = __webpack_public_path__ + "static/media/27OCHA16.e0285997.jpg";